import {
  FETCH_CAMPAIGNS,
  FETCH_CAMPAIGNS_SUCCESS,
  FETCH_CAMPAIGNS_FAILED,
  EDIT_CAMPAIGN,
  SEND_CAMPAIGN,
  SEND_CAMPAIGN_SUCCESS,
  SEND_CAMPAIGN_FAILED
} from "../store/types";

export const INITIAL_STATE = {
  campaigns: null,
  loading: false,
  sending: false,
  error: {
    flag: false,
    msg: null
  }
}

export const campaignreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGNS:
      return {
        ...state,
        loading: true
      };
    case FETCH_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaigns: action.payload,
        loading: false,
        error: { flag: false, msg: null }
      };
    case FETCH_CAMPAIGNS_FAILED:
      return {
        ...state,
        campaigns: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case SEND_CAMPAIGN:
      return {
        ...state,
        sending: true
      };
    case SEND_CAMPAIGN_SUCCESS:
      return {
        ...state,
        sending: false,
        error: { flag: false, msg: null }
      };
    case SEND_CAMPAIGN_FAILED:
      return {
        ...state,
        sending: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_CAMPAIGN:
      return state;
    default:
      return state;
  }
};
